import { firestore } from "@/firebase/web";
import { doc, getDoc } from "firebase/firestore";
import { useEffect, useState } from "react";

const cache = new Map<string, string | null>();
const inflight = new Map<string, Promise<string | null>>();

const fetchPhotoURL = (uid: string): Promise<string | null> => {
  const existing = inflight.get(uid);
  if (existing) return existing;
  const p = getDoc(doc(firestore, "users", uid))
    .then((snap) => {
      const data = snap.exists() ? (snap.data() as { photoURL?: string }) : null;
      const value = data?.photoURL ?? null;
      cache.set(uid, value);
      return value;
    })
    .catch(() => {
      cache.set(uid, null);
      return null;
    })
    .finally(() => {
      inflight.delete(uid);
    });
  inflight.set(uid, p);
  return p;
};

export function useSenderPhotoURL(
  uid: string | undefined | null,
): string | undefined {
  const cached = uid ? cache.get(uid) : undefined;
  const [photoURL, setPhotoURL] = useState<string | undefined>(
    cached === null ? undefined : cached,
  );

  useEffect(() => {
    if (!uid) {
      setPhotoURL(undefined);
      return;
    }
    if (cache.has(uid)) {
      setPhotoURL(cache.get(uid) ?? undefined);
      return;
    }
    let cancelled = false;
    fetchPhotoURL(uid).then((value) => {
      if (!cancelled) setPhotoURL(value ?? undefined);
    });
    return () => {
      cancelled = true;
    };
  }, [uid]);

  return photoURL;
}
